'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _RealtorBenefits = require('./RealtorBenefits.scss');var styles = _interopRequireWildcard(_RealtorBenefits);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var icon = function icon(name) {return (
    _react2.default.createElement('i', { className: 'icon icon-' + name },
      _react2.default.createElement('i', { className: 'path1' }),
      _react2.default.createElement('i', { className: 'path2' }),
      _react2.default.createElement('i', { className: 'path3' }),
      _react2.default.createElement('i', { className: 'path4' }),
      _react2.default.createElement('i', { className: 'path5' }),
      _react2.default.createElement('i', { className: 'path6' }),
      _react2.default.createElement('i', { className: 'path7' }),
      _react2.default.createElement('i', { className: 'path8' }),
      _react2.default.createElement('i', { className: 'path9' }),
      _react2.default.createElement('i', { className: 'path10' }),
      _react2.default.createElement('i', { className: 'path11' }),
      _react2.default.createElement('i', { className: 'path12' }),
      _react2.default.createElement('i', { className: 'path13' }),
      _react2.default.createElement('i', { className: 'path14' }),
      _react2.default.createElement('i', { className: 'path15' }),
      _react2.default.createElement('i', { className: 'path16' })));};



var RealtorBenefits = function RealtorBenefits(props) {return (
    _react2.default.createElement('div', { className: styles.benefitWrapper },
      icon(props.icon),
      _react2.default.createElement('span', { className: styles.title }, props.title),
      _react2.default.createElement('span', null, props.description)));};



RealtorBenefits.propTypes = {
  icon: _propTypes2.default.string,
  title: _propTypes2.default.string,
  description: _propTypes2.default.string };exports.default =


RealtorBenefits;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorBenefits/RealtorBenefits.js
// module id = 2870
// module chunks = 0